export const usePromoEmailMessage = () => {
  return 'acceptEmailsAndSpecialOffers.bk';
};
